import React from "react";

const digitalEra = [
  {
    id: 1,
    icon: <i className="flaticon flaticon-3d"></i>,
    title: "Digital Transformation Hurdles",
    description: `We simplify the transition to digital, enabling businesses to seamlessly integrate new technologies and improve their operations.`,
    link: "/services",
  },
  {
    id: 2,
    icon: <i className="flaticon flaticon-web"></i>,
    title: "Technology Integration Complexities",
    description: `Our expertise lies in making diverse technologies work together harmoniously, enhancing efficiency and productivity.`,
    link: "/services",
    className: "color-two",
  },
  {
    id: 3,
    icon: <i className="flaticon flaticon-database-1"></i>,
    title: `Data Security and Privacy Concerns`,
    description: `With robust security measures, we protect sensitive information from emerging cyber threats, ensuring data integrity and compliance.`,
    link: "/services",
    className: "color-three",
  },
  {
    id: 4,
    icon: <i className="flaticon flaticon-idea-2"></i>,
    title: `Innovation Stagnation`,
    description: `We propel businesses forward by identifying and implementing cutting-edge technologies, keeping them ahead of the curve in a fast-evolving digital landscape.`,
    link: "/services",
    className: "color-four",
  },
  {
    id: 5,
    icon: <i className="flaticon flaticon-setting"></i>,
    title: `Operational Inefficiencies`,
    description: `Our custom solutions optimize business processes, reducing costs and improving service delivery.`,
    link: "/services",
    className: "color-five",
  },
];

export default function OurServices() {
  return (
    <section className="what-we-do-two text-center py-115 rpt-95 rpb-70">
      <div className="container-fluid clearfix px-70">
        <div className="section-title mb-55">
          <span className="sub-title">Addressing Digital Era Challenges</span>
          <h2>Our Solutions Landscape</h2>
        </div>
        <div
          className="grid-container"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(323px, 1fr))",
            gap: "30px",
            alignItems: "stretch",
          }}
        >
          {digitalEra.map(
            ({ id, icon, title, description, link, className }) => (
              <div className="grid-item" key={id}>
                <div
                  className={`feature-item-two ${
                    className ? className : ""
                  } wow fadeInUp delay-0-2s`}
                  style={{
                    height: "100%",
                  }}
                >
                  <div className="icon">{icon}</div>
                  <div className="feature-line">
                    <span className="animate-bar"></span>
                  </div>
                  <h4>
                    <a href={link}>{title}</a>
                  </h4>
                  <p>{description}</p>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
}
